import React from "react";
import { Card, Skeleton, Typography, Row, Col } from "antd";
import { useTranslation } from 'react-i18next'
import { formatPriceNoDecimal } from "helper/common";

const { Title, Text } = Typography;

const AffiliateStatCard = ({ title, value, percent, isAmount, showPercent = false, loading = false }) => {
  const percentValue = Number(percent || 0);
  const percentClass = percentValue >= 0 ? "text-success" : "text-danger";

  return (
    <Card className="h-100 shadow-sm p-2 rounded">
      <div className="d-flex flex-column w-100">
        <Title level={5} className="mb-2 text-secondary text-truncate">
          {title}
        </Title>

        <div className="d-flex align-items-center flex-wrap gap-2">
          {loading ? (
            <Skeleton.Input active size="small" style={{ width: 120 }} />
          ) : (
            <>
              <Title className="text-primary mb-0" level={3}>
                {isAmount ? `${formatPriceNoDecimal(value || 0)}đ` : value || 0}
              </Title>

              {showPercent && (
                percent !== null && percent !== undefined ? (
                  <Text className={`${percentClass} fw-semibold`}>
                    {percentValue >= 0 ? "+" : ""}{percentValue}%
                  </Text>
                ) : (
                  <Text className={`${percentClass} fw-semibold`}>N/A</Text>
                )
              )}
            </>
          )}
        </div>
      </div>
    </Card>
  );
};

const AffiliateOrderStatsWidgets = ({ affiliateOrderStats = {}, loading = false }) => {
  const { t: translate } = useTranslation();

  const { current = {}, previous = {} } = affiliateOrderStats;

  const totalNewOrders = current.totalNewOrders ?? 0;
  const totalCommission = current.totalCommission ?? 0;
  const totalPaymentSuccessFullOrders = current.totalPaymentSuccessFullOrders ?? 0;
  const totalAvenue = current.totalAvenue ?? 0;

  const getPercent = (curr, prev) => {
    const c = Number(curr) || 0;
    const p = Number(prev) || 0;
    if (p === 0) return c > 0 ? 100 : 0;
    const result = ((c - p) / p) * 100;
    return Math.round(result * 100) / 100; // làm tròn 2 chữ số thập phân
  };

  const stats = [
    {
      title: translate("affiliate.widgets.newOrders"),
      value: totalNewOrders,
      percent: getPercent(totalNewOrders, previous.totalNewOrders),
      isAmount: false,
    },
    {
      title: translate("affiliate.widgets.successfulOrders"),
      value: totalPaymentSuccessFullOrders,
      percent: getPercent(totalPaymentSuccessFullOrders, previous.totalPaymentSuccessFullOrders),
      isAmount: false,
    },
    {
      title: translate("affiliate.widgets.revenue"),
      value: totalAvenue,
      percent: getPercent(totalAvenue, previous.totalAvenue),
      isAmount: true,
    },
    {
      title: translate("affiliate.widgets.commission"),
      value: totalCommission,
      percent: getPercent(totalCommission, previous.totalCommission),
      isAmount: true,
    },
  ];

  return (
    <Row gutter={[16, 16]} className="mb-4">
      {stats.map((stat, index) => (
        <Col key={index} xs={24} sm={12} md={12} lg={6}>
          <AffiliateStatCard
            title={stat.title}
            value={stat.value}
            percent={stat.percent}
            isAmount={stat.isAmount}
            showPercent
            loading={loading}
          />
        </Col>
      ))}
    </Row>
  );
};

export default AffiliateOrderStatsWidgets;